import { useRef } from "react"
import { useLocation, useResolvedPath } from "react-router"

// because we're doing modals, the react-router "tech" has a bug where it resolved parameters of modal routes on the parent page
export const useRouteMatch = () => {
  const location = useLocation()
  const myRoute = useRef(useResolvedPath("").pathname)

  return myRoute.current === location.pathname
}
